import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/impulsadoras-promotoras")({
  component: () => <Outlet />,
});
